module.exports = __webpack_public_path__ + "images/emoji/purple_heart.adabaa9f8d24d2b1ab1f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/purple_heart.png
// module id = rEnh
// module chunks = 24